import { TYPE_BOOLEAN } from './input-types';

export const id = 'isVoided';
export const apiKey = 'IsVoid';
export const type = TYPE_BOOLEAN;

export const isVoided = {
  id,
  apiKey,
  type,
};
